import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { Button } from 'reactstrap';

import Analytics from '../../../../analytics/Analytics';
import { modelOf } from '../../../../prop-types';
import AnalyticsService from '../../../../services/AnalyticsService';
import CheckoutStore from '../../../../store/CheckoutStore';
import CheckoutPageModule from '../../../../types/checkout/CheckoutPageModule';
import CheckoutSubmitType from '../../../../types/checkout/CheckoutSubmitType';

const messages = defineMessages({
  checkoutSubmitConfirm: {
    id: 'checkout.checkoutSubmitConfirm',
    defaultMessage: 'Send order',
  },
  checkoutSubmitToPayment: {
    id: 'checkout.checkoutSubmitToPayment',
    defaultMessage: 'Proceed to payment',
  },
});

const CheckoutSubmitButton = ({
  analytics,
  checkoutStore,
  analyticsService,
}) => {
  const { checkoutIsLoading, order } = checkoutStore;
  const disabled = checkoutIsLoading;
  const submitType = order.submit_button_type;

  const submitOrder = (e) => {
    e.preventDefault();
    analyticsService.paymentStart();
    checkoutStore
      .confirmOrder(CheckoutPageModule.SUMMARY_MODULE)
      .then(onSubmitResolve)
      .catch(() => {
        /* No need to send to Sentry */
      });
  };

  const sendGdprData = () => {
    order.gdpr_info && analytics.sendGdprData(order.gdpr_info);
  };

  const onSubmitResolve = () => {
    sendGdprData();
    window.location.assign(order.after_confirm_redirect_url);
  };

  const buttonText = () => {
    return submitType === CheckoutSubmitType.CONFIRM_ORDER
      ? messages.checkoutSubmitConfirm
      : messages.checkoutSubmitToPayment;
  };

  return (
    <div className="CheckoutSubmitButton">
      <Button
        className="CheckoutSubmitButton__button"
        color="primary"
        disabled={disabled}
        onClick={submitOrder}
      >
        <FormattedMessage {...buttonText()} />
      </Button>
    </div>
  );
};

CheckoutSubmitButton.propTypes = {
  checkoutStore: modelOf(CheckoutStore).isRequired,
  analytics: PropTypes.instanceOf(Analytics).isRequired,
  analyticsService: PropTypes.instanceOf(AnalyticsService).isRequired,
};

export default inject(
  'checkoutStore',
  'analytics',
  'analyticsService'
)(observer(CheckoutSubmitButton));
